module.exports = __webpack_public_path__ + "static/media/North-mobile.907f9759.jpg";